import { Benefits } from 'src/app/home/models/benefts.interface';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Plans } from 'src/app/home/models/plans.interface';
import { CommmonService } from 'src/app/utils/common.service';
import { BenefitsService } from 'src/app/home/services/benefits.service';
import { Router } from '@angular/router';
import { RequestFormService } from 'src/app/home/services/request-form.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-add-benefit',
  templateUrl: './add-benefit.component.html',
  styleUrls: ['./add-benefit.component.scss'],
})
export class AddBenefitComponent implements OnInit {
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  @ViewChild('fileInput') fileInput!: ElementRef;
  
  // Objeto para manejar los errores visuales
  errors: any = {};

  isExpanded = true;
  isSizeMobile = false;
  selectOptionTypeBene = '';
  optionCheckCategorias: any[] = [];
  valid = false;
  benefit!: Benefits;
  isNew = true;
  htmlContent = "";
  plans!: Plans[]
  estadoPublicacion: string = 'publicado'; // 'publicado', 'oculto', 'deshabilitado'
  beneficiaryTypes!: any[];
  longDescriptionLength: number = 0;
  titleLength: number = 0;
  descriptionLength: number = 0;
  urlLink = ''
  fileUpload: any;

  subsidiaries: any[] = [];
  
  antiguedad = [
    { 'titulo': 'Sin antigüedad', 'num': 0 },
    { 'titulo': '1 año o más', 'num': 1 },
    { 'titulo': '2 año o más', 'num': 2 },
    { 'titulo': '3 año o más', 'num': 3 },
    { 'titulo': '10 año o más', 'num': 10 },
  ]
  buttonSelection = [
    { 'titulo': 'Nuevo', 'id': 1 },
    { 'titulo': 'Tiempo limitado', 'id': 2 },
    { 'titulo': 'Destacado', 'id': 3 },
    { 'titulo': 'Mejor evaluado', 'id': 4 },
  ];
  selectedStartDate: Date | null = null;
  selectedEndDate: Date | null = null;
  selectedHourInicio: number | null = null;
  selectedHour: number | null = null;
  hours: number[] = [];
  startDateString = ''; 
  endDateString = ''; 
  loading: boolean = false;

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Escribe aquí la descripción...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['subscript', 'superscript'],
      ['textColor', 'backgroundColor', 'link', 'unlink', 'insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat', 'toggleEditorMode']
    ],
    customClasses: [
      { name: "quote", class: "quote" },
      { name: 'redText', class: 'redText' },
      { name: "titleText", class: "titleText", tag: "h1" },
    ]
  };

  constructor(
    private _adapter: DateAdapter<string>,
    private commonService: CommmonService,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    private datePipe: DatePipe,
    private benefitService: BenefitsService,
    private router: Router,
    private serviceUpload: RequestFormService,
    private httpClient: HttpClient
  ) {
    const data = history.state.data;
    if (data) {
      this.benefit = data;
      // Inicializar vigencia si no existe (inferir del estado actual)
      if (this.benefit.vigencia === undefined || this.benefit.vigencia === null) {
        // Inferir vigencia desde statusbt
        if (this.benefit.statusbt) {
          const estadoId = this.benefit.statusbt.id;
          // 3 = Publicado → vigencia false (activo y visible)
          // 1 = Oculto → vigencia false (activo pero oculto)
          // Cualquier otro caso → vigencia true (Deshabilitado/No vigente)
          this.benefit.vigencia = !(estadoId === 3 || estadoId === 1);
        } else {
          this.benefit.vigencia = true;
        }
      }
      this.isNew = false;
    } else {
      this.initDefaultBenefit();
    }
  }

  private initDefaultBenefit() {
    this.benefit = {
      id: 0, detail: '', title: '', image: '', images: [], description: '',
      isCopec: false, isNewBenefit: false, longDescription: '',
      textLabel: { id: 0, nombre: '' }, categories: [], antiques: [],
      beneficiaryTypes: [], plans: [], link: '', descriptionCategories: [],
      statusbt: { id: 3, nombre: '' }, available: false, createdAt: new Date(),
      updatedAt: '', totalStars: 0, average: 0, hidden: false, vigencia: false, glosa: '', subsidiaries: []
    };
  }

  async ngOnInit(): Promise<void> {
    await this.getSubsidiaries();
    await this.getFormData();
    this.editarBeneficioInformativo();
    this.get_schedules();
    this.htmlContent = this.benefit.detail;
    this.updateCharacterCounts();
    this.initEstadoPublicacion();
    console.log(this.benefit.subsidiaries);
  }

  initEstadoPublicacion() {
    // Inicializar el estado según los valores de hidden y vigencia
    if (this.benefit.vigencia === true) {
      this.estadoPublicacion = 'deshabilitado';
    } else if (this.benefit.hidden === true) {
      this.estadoPublicacion = 'oculto';
    } else {
      this.estadoPublicacion = 'publicado';
    }
  }

  async getSubsidiaries() {
    this.subsidiaries = await this.benefitService.getSubsidiaries();
  }

  updateCharacterCounts() {
    this.countTitleCharacters();
    this.countLongDescriptionCharacters();
    this.descriptionCharacters();
  }

  checkedSubsidiaries(sid: any) {
    console.log(sid);
    return true;
  }

  async getFormData() {
    this.optionCheckCategorias = JSON.parse(this.commonService.getItemLocalStorage('categories') ?? '[]')
      .filter((categoria: any) => categoria.id !== -1);
    this.plans = JSON.parse(this.commonService.getItemLocalStorage('plans') ?? '[]');
    this.beneficiaryTypes = JSON.parse(this.commonService.getItemLocalStorage('beneficiaryTypes') ?? '[]');
  }

  selectButton(num: any) {
    this.benefit.textLabel.id = num;
    this.errors.textLabel = false; // Limpiar error al seleccionar
  }

  editarBeneficioInformativo() {
    if (!this.isNew) { this.validacionLink(); }
  }

  validacionLink() {
    if (this.benefit.link.startsWith('/form/')) {
      this.selectOptionTypeBene = "BeneficioPost";
    } else if (this.benefit.link.startsWith('http')) {
      this.urlLink = this.benefit.link;
      this.selectOptionTypeBene = "BeneficioLink";
      this.valid = true;
    } else {
      this.selectOptionTypeBene = "BeneficioInfo";
    }
  }

  publicado() {
    // Actualizar hidden y vigencia según el estado seleccionado
    switch(this.estadoPublicacion) {
      case 'publicado':
        this.benefit.hidden = false;
        this.benefit.vigencia = false;
        break;
      case 'oculto':
        this.benefit.hidden = true;
        this.benefit.vigencia = false;
        break;
      case 'deshabilitado':
        this.benefit.hidden = false;
        this.benefit.vigencia = true;
        break;
    }
    console.log('Estado:', this.estadoPublicacion, 'hidden:', this.benefit.hidden, 'vigencia:', this.benefit.vigencia);
  }

  countLongDescriptionCharacters(): void { this.longDescriptionLength = this.benefit.longDescription?.length || 0; }
  descriptionCharacters(): void { this.descriptionLength = this.benefit.description?.length || 0; }
  countTitleCharacters(): void { this.titleLength = this.benefit.title?.length || 0; }

  abrirLink(): void {
    this.errors.typeBene = false;
    if (this.selectOptionTypeBene === 'BeneficioLink') {
      this.valid = true;
    } else {
      this.benefit.link = '';
      this.valid = false;
      this.errors.link = false;
    }
  }

  categoriasSeleccionadas(category: number, event: MatCheckboxChange) {
    if (event.checked) {
      this.benefit.categories.push(category);
      this.errors.categories = false;
    } else {
      this.benefit.categories = this.benefit.categories.filter(id => id !== category);
    }
  }

  planesSeleccionados(planId: any, event: MatCheckboxChange) {
    if (event.checked) {
      this.benefit.plans.push(planId);
      this.errors.plans = false;
    } else {
      this.benefit.plans = this.benefit.plans.filter(id => id !== planId);
    }
  }

  antiguedadSeleccionada(antId: any, event: any) {
    if (event.checked) {
      this.benefit.antiques.push(antId);
      this.errors.antiques = false;
    } else {
      this.benefit.antiques = this.benefit.antiques.filter(id => id !== antId);
    }
  }

  tipoSeleccionado(event: MatCheckboxChange, typeId: number): void {
    if (event.checked) {
      this.benefit.beneficiaryTypes.push(typeId);
      this.errors.beneficiaryTypes = false;
    } else {
      this.benefit.beneficiaryTypes = this.benefit.beneficiaryTypes.filter(id => id !== typeId);
    }
  }

  subsidiarySelected(event: MatCheckboxChange, subsidiaryId: number): void {
    if (event.checked) {
      this.benefit.subsidiaries.push(subsidiaryId);
      this.errors.subsidiaries = false;
    } else {
      this.benefit.subsidiaries = this.benefit.subsidiaries.filter(id => id !== subsidiaryId);
    }
  }

  get_schedules() {
    for (let i = 1; i <= 24; i++) { this.hours.push(i); }
  }

  generateScheduleStrings(): void {
    if (this.selectedStartDate && this.selectedHourInicio !== null) {
      const startDate = new Date(this.selectedStartDate);
      startDate.setHours(this.selectedHourInicio, 0, 0);
      this.startDateString = this.formatDateToString(startDate);
    }
    if (this.selectedEndDate && this.selectedHour !== null) {
      const endDate = new Date(this.selectedEndDate);
      endDate.setHours(this.selectedHour, 0, 0);
      this.endDateString = this.formatDateToString(endDate);
    }
    this.benefit.createdAt = this.startDateString || this.benefit.createdAt;
    this.benefit.updatedAt = this.endDateString || this.benefit.updatedAt;
  }

  private formatDateToString(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss.SSS Z', '+0000') || '';
  }

  triggerFileInput(): void { this.fileInput.nativeElement.click(); }

  private isImageTooLarge(file: File): boolean {
    const maxSizeInBytes = 500 * 1024; // 500 KB

    if (file.size > maxSizeInBytes) {
      this.errors.image = 'La imagen no debe superar los 500 KB.';
      this.fileUpload = null;
      this.benefit.image = '';
      this.benefit.images = [];
      return true;
    }

    return false;
  }

  displayImage(file: File): void {
    // Validar tamaño máximo 500 KB antes de procesar la imagen
    if (this.isImageTooLarge(file)) {
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result !== null) {
        if (!this.benefit.images) { this.benefit.images = []; }
        this.benefit.images.push({ id: 0, url: file.name });
        this.benefit.image = reader.result;
        this.fileUpload = file;
        this.errors.image = false; // Limpiar error de imagen
      }
    };
    reader.readAsDataURL(file);
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) { this.displayImage(input.files[0]); }
  }

  onDragOver(event: DragEvent): void { event.preventDefault(); }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.displayImage(event.dataTransfer.files[0]);
    }
  }

  removeImageBenefit() {
    this.benefit.image = '';
    this.benefit.images = [];
    this.fileUpload = null;
  }

  async put_file_s3(file: File): Promise<any> {
    try {
      const url_s3 = await this.serviceUpload.get_url_s3({
        s3_object: file.name,
        key_name_bucket: 'cdn_img_benefit'
      });
      const headers = new HttpHeaders({ 'Content-Type': file.type });
      await firstValueFrom(this.httpClient.put(url_s3['upload_url'], file, { headers }));
      return true;
    } catch (error) {
      alert('Ocurrió un error al cargar la imagen');
      return false;
    }
  }

  isBenefitValid(): boolean {
    this.errors = {}; // Resetear errores
    
    // Dividimos la validación en grupos lógicos
    this.validateBasicInfo();
    this.validateBenefitType();
    this.validateComplementaryInfo();
    this.validatePublication();

    const isValid = Object.keys(this.errors).length === 0;
    
    if (!isValid) {
      this.scrollToFirstError();
    }
    
    return isValid;
  }

  private validateBasicInfo(): void {
    const b = this.benefit;
    if (!b.title?.trim()) this.errors.title = true;
    if (!b.description?.trim()) this.errors.description = true;
    if (!b.longDescription?.trim()) this.errors.longDescription = true;
    if (!b.glosa) this.errors.glosa = true;
    if (!b.image) this.errors.image = true;
    
    const isHtmlEmpty = !this.htmlContent?.trim() || this.htmlContent === '<p><br></p>';
    if (isHtmlEmpty) this.errors.htmlContent = true;
  }

  private validateBenefitType(): void {
    if (!this.selectOptionTypeBene) {
      this.errors.typeBene = true;
    }
    
    const isLinkInvalid = this.selectOptionTypeBene === 'BeneficioLink' && !this.benefit.link?.trim();
    if (isLinkInvalid) {
      this.errors.link = true;
    }
  }

  private validateComplementaryInfo(): void {
    const b = this.benefit;
    if (b.categories.length === 0) this.errors.categories = true;
    if (b.plans.length === 0) this.errors.plans = true;
    if (b.antiques.length === 0) this.errors.antiques = true;
    if (b.beneficiaryTypes.length === 0) this.errors.beneficiaryTypes = true;
    if (b.subsidiaries.length === 0) this.errors.subsidiaries = true;
    if (!b.textLabel || b.textLabel.id === 0) this.errors.textLabel = true;
  }

  private validatePublication(): void {
    // Validar que se haya seleccionado un estado válido
    if (!this.estadoPublicacion) {
      this.errors.hidden = true;
    }
  }

  scrollToFirstError() {
    setTimeout(() => {
      const firstErrorElement = document.querySelector('.error-text');
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  async pushBenefit() {
    this.benefit.detail = this.htmlContent;
    this.generateScheduleStrings();

    if (!this.isBenefitValid()) {
      return; 
    }

    console.log('Enviando beneficio con vigencia:', this.benefit.vigencia, 'hidden:', this.benefit.hidden);

    // Lógica de carga de imagen y posteo
    if (this.fileUpload) {
      const response = await this.put_file_s3(this.fileUpload);
      if (response) {
        this.benefit.image = ''; // El backend suele manejar la URL final
        await this.postSetBeneficios(this.benefit);
      }
    } else {
      await this.postSetBeneficios(this.benefit);
    }
  }

  async postSetBeneficios(payload: any) {
    try {
      const response: any = await this.benefitService.setAndPostBenefit(payload);
      if (response.statusCode === 200) {
        this.router.navigate(['/admin/benefits']);
      }
    } catch (error) {
      alert('No ha sido posible concretar su petición');
    }
  }
}
